:host {
  display: block;
}

.container {
  margin: var(--s2) 0;
}

.heading {
  color: var(--color-cwru-blue);
  font-size: var(--s2);
  font-weight: var(--font-weight-semibold);
  margin-top: 0;
  margin-bottom: var(--s0);
  line-height: 1.2em;
}

.content {
  flex-grow: 1;
  padding: var(--s0) var(--s-1);
}

* {
  font-size: var(--s1);
}
